import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

// books/fetchBooks is an action type prefix and is used
// internally with pending, fulfilled, rejected
// each of these createAsyncThunks return promises
export const fetchBooks = createAsyncThunk("books/fetchBooks", async () => {
  const response = await axios.get(`${BASE_URL}/api/books`);
  return response.data;
});

export const fetchBook = createAsyncThunk("books/fetchBook", async (sid) => {
  const response = await axios.get(`${BASE_URL}/api/books/${sid}`);
  return response.data;
});

export const createBook = createAsyncThunk(
  "books/createBook",
  async (newBook) => {
    const response = await axios.post(`${BASE_URL}/api/books`, newBook);
    return response.data;
  }
);

export const updateBook = createAsyncThunk(
  "books/updateBook",
  async (bookUpdate) => {
    const response = await axios.put(`${BASE_URL}/api/books`, bookUpdate);
    return response.data;
  }
);

export const deleteBook = createAsyncThunk("books/deleteBook", async (sid) => {
  const response = await axios.delete(`${BASE_URL}/api/books/${sid}`);
  return response.data;
});

const bookSlice = createSlice({
  name: "books",
  initialState: {
    books: [],
    book: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearBook: (state) => {
      state.book = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch books
      .addCase(fetchBooks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBooks.fulfilled, (state, action) => {
        state.books = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBooks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // fetch book
      .addCase(fetchBook.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.book = null;
      })
      .addCase(fetchBook.fulfilled, (state, action) => {
        state.book = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchBook.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // create book
      .addCase(createBook.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createBook.fulfilled, (state, action) => {
        state.book = action.payload; // created book
        state.isLoading = false;
      })
      .addCase(createBook.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // update book
      .addCase(updateBook.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateBook.fulfilled, (state, action) => {
        state.book = action.payload; // updated book
        state.isLoading = false;
      })
      .addCase(updateBook.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // delete book
      .addCase(deleteBook.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteBook.fulfilled, (state, action) => {
        state.book = null; // book deleted
        state.isLoading = false;
      })
      .addCase(deleteBook.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearBook } = bookSlice.actions;

export default bookSlice.reducer;
